import type { ProductImage, UploadImage } from "@shared/types";

export const PLACEHOLDER_IMAGE = "/placeholder.svg";

/**
 * Resolves the best available product image using a priority chain:
 *   1. PIM / product image (`images[0].src`)
 *   2. Draft / uploaded image (`imageUploads[0].url`)
 *   3. Placeholder (`/placeholder.svg`)
 *
 * @param images     - ProductImage array from the product payload
 * @param imageUploads - UploadImage array from draft or form state
 * @returns The resolved image URL string
 */
export const resolveProductImage = (images?: ProductImage[], imageUploads?: UploadImage[] | null): string => {
  const pimImage = images?.[0]?.src;
  if (pimImage) return pimImage;

  const draftImage = imageUploads?.[0]?.url;
  if (draftImage) return draftImage;

  return PLACEHOLDER_IMAGE;
};
